// import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { HttpMethod } from '../../Asset/httpMethod';

// const ResetPassword = () => {

//   const query = new URLSearchParams(useLocation().search);
//   const email = query.get('email');
//   const token = query.get('token');

//   const [password, setPassword] = useState('');
//   const [msg, setMsg] = useState('');

//   const handleSubmit = async (e) => {
//     console.log(email);
//     console.log(token);
//     e.preventDefault();
//     try {
//       await HttpMethod.post('/Authorization/Account/ResetPassword', {
//         email,
//         token,
//         Password: password,
//         ConfirmPassword: password
//       });
//       setMsg('Password reset successful!');
//     } catch (err) {
//       setMsg(err.response?.data || 'Reset failed');
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <div className="login-container">
//         <div className="login-box">
//           <h2>Reset Password</h2>
//           <div className="mb-3">
//           <input type="password"
//             value={password}
//             className="form-control"
//             onChange={(e) => setPassword(e.target.value)} required
//             placeholder="New Password" />
//             </div>
//             <div className="">
//           <input type="password"
//             value={password}
//             className="form-control"
//             onChange={(e) => setPassword(e.target.value)} required
//             placeholder="reset Password" />
//             </div>
//           <button  className="savepanelBtn btn-primary ml-md-2 w-50 my-3" type="submit">Reset Password</button>
//           <p>{msg}</p>
//         </div>
//       </div>
//     </form>
//     // <form onSubmit={handleSubmit}>
//     //   <h2>Reset Password</h2>
//     //   <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="New Password" />
//     //   <button type="submit">Reset Password</button>
//     //   <p>{msg}</p>
//     // </form>
//   );
// };

// export default ResetPassword;
import React, { useEffect, useState } from "react";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { HttpMethod } from '../../Asset/httpMethod';
import { AlertPopup } from "../../Asset/common";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emailid, setEmailid] = useState("");
  const [token, setToken] = useState("");

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(''); 
  const navigate = useNavigate(); // inside your component

  // const query = new URLSearchParams(window.location.search.replace(/&amp;/g, "&"));
  // const emailid = query.get("email");
  // const token = query.get("token");


  // ✅ Get token as-is (encoded)
  useEffect(() => {
    // const rawSearch = window.location.search.replace(/&amp;/g, "&");
    // const params = new URLSearchParams(rawSearch);
    // setEmailid(params.get("email") || "");
    // setToken(params.get("token") || ""); // NO decode here

     // Do not decode — extract raw token
    const rawToken = window.location.search.match(/token=([^&]+)/)?.[1] || "";
    const emailParam = window.location.search.match(/email=([^&]+)/)?.[1] || "";
    setEmailid(decodeURIComponent(emailParam)); // Decode only email
    setToken(rawToken); // Leave token URL-encoded

  }, []);
 

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    } 

    if (!emailid || !token) {
      setError("Invalid Reset Password link");
      return;
    }
  
    try {
      debugger
      await HttpMethod.post("/Authorization/Account/ResetPassword", {
        Email: emailid.trim(),
        Password: password,
        ConfirmPassword: confirmPassword,
        Token: token.trim(),
      });      

      AlertPopup.SuccessPopup("Password successfully changed!");

      setPassword("");
      setConfirmPassword("");       
      navigate("/login"); // adjust route to match your actual login page route

    } catch (err) {
      setError(err.response?.data || "Something went wrong");      
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="login-container">
        <div className="login-box">
          <h2>Reset Password</h2>

          {/* New password */}
          <div className="mb-3 position-relative">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              className="form-control pe-5"
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter new password"
            />
            <span
              className="position-absolute top-50 end-0 translate-middle-y me-3"
              style={{ cursor: "pointer", fontSize: "1.2rem", color: "#666" }}
              onClick={() => setShowPassword((p) => !p)}
            >
              {showPassword ? <IoEyeOff /> : <IoEye />}
            </span>
          </div>

          {/* Confirm password */}
          <div className="mb-3 position-relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              className="form-control pe-5"
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />
            <span
              className="position-absolute top-50 end-0 translate-middle-y me-3"
              style={{ cursor: "pointer", fontSize: "1.2rem", color: "#666" }}
              onClick={() => setShowConfirmPassword((p) => !p)}
            >
              {showConfirmPassword ? <IoEyeOff /> : <IoEye />}
            </span>
          </div>

          {error && <p style={{ color: "red" }}>{error}</p>}

          <button type="submit" className="btn btn-primary w-75 mt-3">
            Reset Password
          </button>
        </div>
      </div>
    </form>
  );
}

export default ResetPassword;
